import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { TrendingUp } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-row items-center justify-center gap-8 w-[45%] bg-[#26231E] text-white p-12">
        <div className="h-20 flex items-center justify-center">
          <img
            src="/logo-tek.png"
            alt="Tek Hukuk"
            className="h-full w-auto object-contain"
          />
        </div>
        <div className="w-px h-16 bg-[#B8933F]/50" />
        <div className="h-20 flex items-center justify-center" style={{ transform: "translateY(-12px)" }}>
          <img
            src="/logo-gencer.png"
            alt="Gençer — 35 Yıllık Deneyim"
            className="h-14 w-auto object-contain"
          />
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <img src="/logo-tek.jpg" alt="Tek Hukuk" className="h-16 sm:h-20 w-auto mb-6 mx-auto lg:mx-0" style={{ mixBlendMode: "multiply" }} />
          <div className="kicker mb-2">HOŞ GELDİNİZ</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight mb-8">Giriş Yap</h2>

          {error && (
            <div
              className="mb-4 px-3 py-2 bg-[#A63A3A]/10 border border-[#A63A3A]/30 text-[#A63A3A] text-sm rounded-sm"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <label className="kicker block mb-1.5">E-POSTA</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="login-email-input"
            className="w-full px-3 py-2.5 border border-[#E7DECC] rounded-sm mb-4 focus:outline-none focus:border-[#26231E] focus:ring-1 focus:ring-[#26231E]"
            placeholder="ornek@sirket.com"
          />

          <label className="kicker block mb-1.5">ŞİFRE</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="login-password-input"
            className="w-full px-3 py-2.5 border border-[#E7DECC] rounded-sm mb-6 focus:outline-none focus:border-[#26231E] focus:ring-1 focus:ring-[#26231E]"
            placeholder="••••••••"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-[#26231E] hover:bg-[#262626] text-white py-2.5 rounded-sm font-medium transition-colors duration-150 disabled:opacity-60"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>

          <p className="mt-6 text-sm text-[#8C8377]">
            Hesabınız yalnızca yönetici tarafından oluşturulur.
          </p>
        </form>
      </div>
    </div>
  );
}
